var displayLeader = function() {
    var uuid = this.getAttribute("data-target");
    var leaderModal = document.getElementById(uuid);
    var bodyObj = document.body;
    leaderModal.classList.add("leader__modal--active");
    //push nav & footer back on open
    bodyObj.classList.add("body--pushToBack");
    bodyObj.style.overflow = "hidden";

    const parent = this.closest(".executiveLeadership");
    const closeModal = leaderModal.querySelector(".modal__close");

    parent.classList.add("executiveLeadership--topLayer");
    closeModal.focus();

    const closeEvent = () => {
        leaderModal.classList.remove("leader__modal--active");
        bodyObj.classList.remove("body--pushToBack");
        bodyObj.style.overflow = "auto";
        parent.classList.remove("executiveLeadership--topLayer");
    };

    closeModal.addEventListener("click", () => {
        closeEvent();
    });
    leaderModal.addEventListener("click", () => {
        closeEvent();
    });
    leaderModal.querySelector(".modal__inner ").addEventListener("click", e => {
        e.stopPropagation();
    });

    const modalEnd = leaderModal.querySelector(".modal__end");
    modalEnd.addEventListener("focus", () => {
        closeModal.focus();
    });
};

function triggerLeaderModal() {
    if (document.getElementsByClassName("leader__more")[0]) {
        var modalTriggers = document.getElementsByClassName("leader__more");
        Array.from(modalTriggers).forEach(function(e) {
            e.addEventListener("click", displayLeader);
        });
    }
}

function init() {
    triggerLeaderModal();
}

export default { init };
